module.exports = {
    at: 'Österreich',
    be: 'Belgien',
    ch: 'Schweiz',
    cl: 'Chile',
    cz: 'Tschechien',
    de: 'Deutschland',
    dk: 'Dänemark',
    es: 'Spanien',
    fi: 'Finnland',
    fr: 'Frankreich',
    gb: 'Vereinigtes Königreich',
    hu: 'Ungarn',
    ie: 'Irland',
    it: 'Italien',
    lu: 'Luxemburg',
    nl: 'Niederlande',
    no: 'Norwegen',
    pl: 'Polen',
    pt: 'Portugal',
    se: 'Schweden',
    si: 'Slowenien',
    sk: 'Slowakei',
    ua: 'Ukraine',
    us: 'Vereinigte Staaten von Amerika',
};
